var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};

ready(function () {
  /*
  |-----------------------------------------
  | Sticky Header
  |-----------------------------------------
  | Sticky header when scrolling.
  */
  const header = document.querySelector(".header");
  window.addEventListener("scroll", function (e) {
    let currentScroll = window.pageYOffset;
    if (currentScroll > 174) {
      header.classList.add("stuck");
    } else {
      header.classList.remove("stuck");
    }
  });

  /*
  |-----------------------------------------
  | Nav
  |-----------------------------------------
  | Main navigation menus. And, Close any open
  | menu when clicking outside the nav (desktop only).
  */
  let navigationListItemLinks = document.querySelectorAll(".navigation-list-item-link");
  navigationListItemLinks.forEach(function (el) {
    el.addEventListener("click", function (event) {
      document.querySelectorAll(".navigation-list-item").forEach(function (listItem) {
        let clickParent = event.target.closest(".navigation-list-item");
        if (listItem != clickParent) {
          if (window.matchMedia("(min-width: 64rem)").matches) {
            listItem.classList.remove("open");
          }
        }
      });
      let parentEl = el.closest(".navigation-list-item:not(.back)");
      if (parentEl.classList.contains("open") == true) {
        parentEl.classList.remove("open");
      } else {
        parentEl.classList.add("open");
      }
    });
  });
  document.addEventListener("mouseup", function (e) {
    let navItem = e.target.closest(".navigation");
    if (navItem == null) {
      document.querySelectorAll(".navigation-list-item").forEach(function (listItem) {
        listItem.classList.remove("open");
      });
    }
  });
});

/*
|-----------------------------------------
| Toggle Mobile Menu
|-----------------------------------------
| Toggles the main navigation on mobile.
*/
function toggleNav() {
  const page = document.querySelector("html");
  if (page.classList.contains("navOpen") == true) {
    page.classList.remove("navOpen");
    page.classList.remove("fixViewPort");
  } else {
    page.classList.add("navOpen");
    page.classList.add("fixViewPort");
  }
}

// ===== EXISTING SCRIPTS ===== //
$(document).ready(function () {
  /*
  |-----------------------------------------
  | USPs Carousel
  |-----------------------------------------
  | Carousel for the USPs located underneath banners.
  | This uses the built-in "slickSlider.js" located
  | within the app.js scripts in the  Age Co framework.
  |
  */
  $("#usps .carousel").slick({
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 300,
    arrows: false,
    adaptiveHeight: false,
    accessibility: true,
    mobileFirst: false,
    responsive: [
      {
        breakpoint: 10000,
        settings: "unslick",
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /*
  |-----------------------------------------
  | Radio Button Focus
  |-----------------------------------------
  | Adds focus highlight to radio buttons.
  |
  */
  $('input[type="radio"]').on("focusin", function () {
    $(this).parent("label").addClass("focus");
  });
  $('input[type="radio"]').on("focusout", function () {
    $(this).parent("label").removeClass("focus");
  });

  /*
  |-----------------------------------------
  | Custom Tabs
  |-----------------------------------------
  | Simplified version of the tabs. This is used
  | on the compare products page.
  |
  */
  $(".customTabs-tabs").each(function (index, el) {
    $(el).find("li").first().addClass("active-tab");
  });
  $(".customTabs a").click(function (event) {
    event.preventDefault();
    var $parent = $(this).closest(".customTabs");
    $parent.find("li").removeClass("active-tab");
    $(this).parent("li").addClass("active-tab");
  });

  /*
  |-----------------------------------------
  | Date of Birth
  |-----------------------------------------
  | Controls the date of birth fields in the checkout.
  | This is so we're not sending 3 seperate fields, but
  | only one instead.
  |
  | This should run before any of the text label
  | adjustment scripts below.
  |
  */
  $(".js--dob-selector").on("input", function () {
    var $day = $('.js--dob-selector[name="dob_day"]');
    var $month = $('.js--dob-selector[name="dob_month"]');
    var $year = $('.js--dob-selector[name="dob_year"]');
    var fullDoB = "";
    if ($day.val() != "" && $month.val() != "" && $year.val() != "") {
      fullDoB = $day.val() + "/" + $month.val() + "/" + $year.val();
    }
    $("#js--dob-selector").val(fullDoB);
  });

  // Re-select the date of birth if it's been set
  var dobValue = $("#js--dob-selector").val();
  if (dobValue != "" && dobValue != undefined) {
    var dobParts = dobValue.split("/");
    $('.js--dob-selector[name="dob_day"]').val(dobParts[0]);
    $('.js--dob-selector[name="dob_month"]').val(dobParts[1]);
    $('.js--dob-selector[name="dob_year"]').val(dobParts[2]);
  }
});

/*
|-----------------------------------------
| Trustpilot Reviews
|-----------------------------------------
| Displays the trustpilot review cards.
|
| @param perPage (int) - Number of reviews to return.
| @param target (string) - Element Id e.g. "#reviews"
| @param icon_asset (string) - URL to icon asset
|
*/
var showTrustpilotReviews = function (perPage, target, icon_asset) {
  if (perPage == undefined || perPage == 0) {
    perPage = 4;
  }

  $.ajax({
    url: "https://api.trustpilot.com/v1/business-units/5cf0e169dc20be0001fcca03/reviews",
    type: "GET",
    data: {
      apikey: "dYXut53QnN58DCh7TuihjVQrdc4rIZVE",
      language: "en",
      perPage: perPage,
      stars: [4, 5],
    },
    dataType: "json",
    success: function (response) {
      var template = "";
      var wordLimit = 20;
      var reviews = response.reviews;

      $.each(reviews, function (index, review) {
        let c = index + 1;

        // Truncate the content if it's more than
        // the wordLimit set above.
        var content = review.text;
        content.trim();

        // Count the number of words.
        var wordCount = content.split(" ").length;

        // Convert the content into an array of words and
        // remove any words above the limit.
        content = content.split(" ").slice(0, wordLimit);

        // Convert the array of words back into a string
        // If there's content to add after it, add it.
        content = content.join(" ");
        if (wordCount > wordLimit) {
          content += ` <a href="https://uk.trustpilot.com/reviews/` + review.id + `" target="_blank">...</a>`;
        }

        // Desktop class (showing only 2 on mobile)
        var cssClass = "";
        if (c >= 3) {
          cssClass = "";
        }

        // Make the date nice.
        var reviewDate = new Date(review.createdAt);
        var publishedDate =
          reviewDate.getDate() +
          " " +
          reviewDate.toLocaleString("en-GB", { month: "long" }) +
          " " +
          reviewDate.getFullYear();

        // Create the HTML card.
        template += `
          <div class="review-card${cssClass}">
            <blockquote>
              <p>${content}</p>
              <ul class="review-stars">`;
        for (var i = 0; i < review.stars; i++) {
          template += `<li><img src="${icon_asset}" alt="Star icon"></li>`;
        }
        template += `</ul>
              <div class="testimonial-footer">
                &mdash; ${review.consumer.displayName} (${publishedDate})
              </div>
            </blockquote>
          </div>`;
      });

      $(target).append(template);
    },
  });
};

/*
|-----------------------------------------
| Get Query String Parameter
|-----------------------------------------
| Returns value of query string parameter,
| where its key is 'name'.
|
*/
var getParam = function (name) {
  if ("URLSearchParams" in window) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  } else {
    // Polyfill for IE11
    var params = new RegExp("[?&]" + name + "=([^&#]*)").exec(window.location.href);
    if (params == null) {
      return null;
    } else {
      return decodeURI(params[1]) || 0;
    }
  }
};

/*
|-----------------------------------------
| Set Query String Parameter
|-----------------------------------------
| Appends a new key/value parameter to the
| existing query string url and returns
| the full string.
|
*/
var setParam = function (key, value) {
  var queryString = "";
  var params = new URLSearchParams(window.location.search);
  params.set(key, value);
  queryString = decodeURIComponent(params.toString());
  queryString = queryString.replace(/\+/g, "%20");
  return queryString;
};

/*
|-----------------------------------------
| Remove Cart Items
|-----------------------------------------
| Removes items from the cart. All this does is
| set the variant quantities to 0 in order to
| remove them from the cart.
|
| @param itemKeyArray (array) - An array of cart item keys.
|
*/
var removeCartItems = function (itemKeyArray) {
  var confirmRemoval = confirm("Are you sure you want to remove this item from your cart?");
  if (confirmRemoval == true) {
    var items = { updates: {} };
    $.each(itemKeyArray, function (index, itemKey) {
      items.updates[itemKey] = 0;
    });
    if (itemKeyArray.length > 0) {
      $.ajax({
        url: "/cart/update.js",
        type: "post",
        dataType: "json",
        data: items,
        success: function (response) {
          window.location.href = "/cart";
        },
      });
    }
  }
};

/*
|-----------------------------------------
| Validation Cart
|-----------------------------------------
| Checks the required fields have been completed
| before allowing the customer to proceed to payment.
|
*/
var validateCart = function () {
  var validationSuccess = true;
  var $cart = $("form#cart-form");

  // Reset all error messages
  $(".form-error").remove();
  $(".form-input").removeClass("form-input-error");

  // Check all required text fields.
  $("input:required, textarea:required, select:required", $cart).each(function (index, el) {
    let $parent = $(el).parent("div");
    let inputLabel = $parent.find("label").text().replace(" *", "");
    let valueLength = $(el).val().length;
    let minLength = 0;

    if ($(el).attr("minlength") != undefined && $(el).attr("minlength") != false) {
      minLength = parseInt($(el).attr("minlength"));
    }

    if ($(el).val() == "" || valueLength < minLength) {
      validationSuccess = false;
      $(el).addClass("form-input-error");
      if (valueLength < minLength && $(el).val() != "") {
        $parent.append(
          '<span class="form-error" aria-hidden="true">' +
            inputLabel +
            " should be " +
            minLength +
            " characters or more.</span>"
        );
      }
    }
  });

  // Validate telephone number
  var $telephone = $("input.valid-phone");
  if ($telephone.val().length > 0 && $telephone.val().length < 6) {
    validationSuccess = false;
    var $parent = $telephone.closest("div");
    $telephone.addClass("form-input-error");
    $parent.append('<span class="form-error" aria-hidden="true">Telephone number should be 6 numbers or more.</span>');
  }

  // Validate postcode (uppercase and starts with a letter)
  var $postcode = $("input.valid-postcode");
  if ($postcode.val().length > 0) {
    var $postcodeParent = $postcode.closest("div");
    var postcodeValue = $postcode.val().toUpperCase();
    $postcode.val(postcodeValue);
    if (/^[a-zA-z]([a-zA-Z0-9]+?)\s(.+?)$/gm.test(postcodeValue) == false) {
      validationSuccess = false;
      $postcode.addClass("form-input-error");
      $postcodeParent.append(
        '<span class="form-error" aria-hidden="true">Postcode should begin with a letter and include a space.</span>'
      );
    }
  }

  // Check terms and conditions checkbox is ticked.
  if ($('input[name="terms"]').is(":checked") == false) {
    validationSuccess = false;
    $('input[name="terms"]').addClass("form-input-error");
  } else {
    $('input[name="terms"]').removeClass("form-input-error");
  }

  // If validation fails, focus on the first error.
  if (validationSuccess == false) {
    $(".form-input-error").first().focus();
    if ($("p.errors").length == 0) {
      $('button[name="checkout"]')
        .parent("p")
        .before(
          '<p class="errors center"><strong class="red">Please complete all the required fields highlighted above.</strong></p>'
        );
    }
  } else {
    $("p.errors").remove();
    // Append checkout query params to form action so the customer's
    // details are passed through to the Shopify checkout.
    let firstName = "";
    let lastName = "";
    let address1 = "";
    let address2 = "";
    let city = "";
    let zip = "";
    if (document.querySelector('input[name="attributes[For]"][value="Myself"]').checked == true) {
      firstName = document.getElementById("customer_first_name").value;
      lastName = document.getElementById("customer_last_name").value;
      address1 = document.getElementById("customer_address1").value;
      address2 = document.getElementById("customer_address2").value;
      city = document.getElementById("customer_city").value;
      zip = document.getElementById("customer_postcode").value;
    }
    let checkoutParams = [
      `checkout[shipping_address][first_name]=${firstName}`,
      `checkout[shipping_address][last_name]=${lastName}`,
      `checkout[shipping_address][address1]=${address1}`,
      `checkout[shipping_address][address2]=${address2}`,
      `checkout[shipping_address][city]=${city}`,
      `checkout[shipping_address][zip]=${zip}`,
    ].join("&");
    document.forms["cart-form"].setAttribute("action", `/cart?${checkoutParams}`);
  }

  return validationSuccess;
};

/*
|-----------------------------------------
| Show Discount Code Box
|-----------------------------------------
| On click of link, show the discount code
| box in the cart.
|
*/
var showDiscountCode = function () {
  $(".js--discount_code").hide();
  $("#js--discount_code").removeClass("hide").find('input[name="discount_code"]').focus();
};

/*
|-----------------------------------------
| Validate Form
|-----------------------------------------
| Checks for required fields before submitting.
| This function is use for the contact forms.
|
| @param btn = this
|
*/
var validateForm = function (btn) {
  var validationSuccess = true;
  var $form = $(btn).closest("form");

  // Reset all error messages
  $(".form-error").remove();
  $(".form-input").removeClass("form-input-error");

  // Check all required text fields.
  $("input:required, textarea:required, select:required", $form).each(function (index, el) {
    let $parent = $(el).parent("div");
    let inputLabel = $parent.find("label").text().replace(" *", "");
    let valueLength = $(el).val().length;
    let minLength = 0;

    if ($(el).attr("minlength") != undefined && $(el).attr("minlength") != false) {
      minLength = parseInt($(el).attr("minlength"));
    }

    // Check a value has been entered
    if ($(el).val() == "" || valueLength < minLength) {
      validationSuccess = false;
      $(el).addClass("form-input-error");
      if (valueLength < minLength && $(el).val() != "") {
        $parent.append(
          '<span class="form-error" aria-hidden="true">' +
            inputLabel +
            " should be " +
            minLength +
            " characters or more.</span>"
        );
      }
    }

    // Check for a valid email
    if ($(el).attr("type") == "email" && $(el).val() != "") {
      var pattern =
        /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      if ($.trim($(el).val()).match(pattern) == null) {
        validation = false;
        $(el).addClass("form-input-error");
        $parent.append('<span class="form-error" aria-hidden="true">Please enter a valid email address.</span>');
      }
    }
  });

  return validationSuccess;
};
